import { ErrorCode } from '../../../dtos/error-message.dto';
import { MAX_APPS } from '../../../utils/constants';

export interface ErrorDetails {
    title: string;
    message?: string;
    okText: string;
}

export const errorsMap: Record<string, ErrorDetails> = {
    [ErrorCode.SPECIFIC_ERR_BAD_REQUEST.toString()]: {
        title: 'Error!',
        okText: 'Ok'
    },
    [ErrorCode.EXCEED_COUNT.toString()]: {
        title: 'Maximum Apps Reached',
        message: `You've reached the limit of ${MAX_APPS} managed apps`,
        okText: 'Got it'
    }
};